var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('InternalDossierForm',{attrs:{"isPatMode":_vm.isPatMode,"dossierReference":_vm.$route.params.reference}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }